"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var _UIForm = _interopRequireDefault(require("UIComponents/form/UIForm"));

var _BookingFormField = _interopRequireDefault(require("./BookingFormField"));

var _FullNameInput = _interopRequireDefault(require("ui-addon-i18n/components/FullNameInput"));

var _CustomFormInputs = _interopRequireDefault(require("MeetingsLib/components/input/CustomFormInputs"));

var _default = (0, _createReactClass.default)({
  displayName: "BookingFormFields",
  propTypes: {
    centerPropertyForm: _propTypes.default.bool,
    formFields: _propTypes.default.instanceOf(_immutable.List).isRequired,
    formStateValidation: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    formState: _propTypes.default.instanceOf(_FormState.default),
    setFormValue: _propTypes.default.func.isRequired
  },
  renderField: function renderField(fieldName) {
    var _this$props = this.props,
        formStateValidation = _this$props.formStateValidation,
        formState = _this$props.formState,
        setFormValue = _this$props.setFormValue;
    return _react.default.createElement(_BookingFormField.default, {
      fieldName: fieldName,
      validation: formStateValidation.get(fieldName),
      fieldValue: formState.get(fieldName),
      isRequired: true,
      fieldLabel: _react.default.createElement(_FormattedMessage.default, {
        message: "prebook.details.field." + fieldName
      }),
      setFormValue: setFormValue,
      autocomplete: "on"
    });
  },
  renderCustomFormFields: function renderCustomFormFields() {
    var _this$props2 = this.props,
        formFields = _this$props2.formFields,
        formStateValidation = _this$props2.formStateValidation,
        formState = _this$props2.formState,
        setFormValue = _this$props2.setFormValue;
    return _react.default.createElement(_CustomFormInputs.default, {
      formFields: formFields,
      formStateValidation: formStateValidation.get('customFormFields'),
      customFormFields: formState.get('customFormFields'),
      onCustomFormFieldChange: setFormValue
    });
  },
  renderNameFields: function renderNameFields() {
    return _react.default.createElement(_FullNameInput.default, {
      direction: "row",
      wrap: "wrap",
      givenNameInput: this.renderField('firstName'),
      familyNameInput: this.renderField('lastName')
    });
  },
  render: function render() {
    var className = 'p-x-1 p-bottom-4' + (this.props.centerPropertyForm ? " p-x-15" : "");
    return _react.default.createElement(_UIForm.default, {
      className: className
    }, this.renderNameFields(), this.renderField('email'), this.renderCustomFormFields());
  }
});

exports.default = _default;
module.exports = exports.default;